import { forwardRef } from "react";
import { ProjectCard } from "./ProjectCard";
import type { Project } from "../types/Project";

type ProjectGridProps = {
  projects: Project[];
  onOpenProject: (project: Project) => void;
  onFocusProject: (index: number) => void;
};

export const ProjectGrid = forwardRef<HTMLDivElement, ProjectGridProps>(
  ({ projects, onOpenProject, onFocusProject }, ref) => {
    return (
      <section className="mb-8">
        <div
          ref={ref}
          className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 auto-rows-fr"
        >
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={index}
              onOpen={onOpenProject}
              onFocus={onFocusProject}
            />
          ))}
        </div>
      </section>
    );
  }
);

ProjectGrid.displayName = "ProjectGrid";
